import { React, useState, useEffect, useRef } from "react";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import {
  Menu,
  MenuItem,
  MenuItemLink,
  MenuSelectEvent,
} from "@progress/kendo-react-layout";
import { ExcelExport } from "@progress/kendo-react-excel-export";

const initialSort: any[] = [
  {
    field: "key",
    dir: "desc",
  },
];

interface SupportCasesGridProps {
  data?: any | null;
}

const SupportCasessGrid = (props: SupportCasesGridProps) => {
  const [data, setData] = useState(props.data || []);
  const [sort, setSort] = useState(initialSort);
  const [isPagable, updateIsPagable] = useState(false);
  const [page, setPage] = useState({
    skip: 0,
    take: 4,
  });
    useEffect(() => {
        if (props.data != null) {
            setData(props.data);
        }
  }, [props.data]);

  const pageChange = (event) => {
    setPage(event.page);
  };
  const download = (fileUrl: string) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    //link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
    const pathCell = (cellprops: any) => {
        const getLinkName = () => {
            if (cellprops.dataItem.linkName != null && cellprops.dataItem.linkName != "") {

                return (cellprops.dataItem.linkName)
            }
            else {return "Link" }
        }
    if (cellprops.dataItem.path == null) return <td></td>;
    if (cellprops.dataItem.path.includes("machinefiles")) {
      return (
        <td
          style={{ cursor: "pointer" }}
          onClick={() => download(cellprops.dataItem.path)}
        >
              {getLinkName()}
        </td>
      );
    }
    return (
      <td>
        <a href={cellprops.dataItem.path} target="blank">
                {getLinkName()}
        </a>
      </td>
    );
  };
    const descCell = (cellprops: any) => {
        if (cellprops.dataItem.path == null) return <td></td>;
        if (cellprops.dataItem.path.includes("machinefiles")) {
            return (
                <td
                    style={{ cursor: "pointer" }}
                    onClick={() => download(cellprops.dataItem.path)}
                >
                    {cellprops.dataItem.fileName}
                </td>
            );
        }
        return (
            <td>
                <a href={cellprops.dataItem.path} target="blank">
                   { cellprops.dataItem.fileName}
                </a>
            </td>
        );
    };
  const _export = useRef<ExcelExport | null>(null);
  const excelExport = (event: MenuSelectEvent) => {
    if (event.item.text === "Export to Excel") {
      if (_export.current !== null) {
        _export.current.save();
      }
    }
  };
  const linkRender = (props: any) => {
    return (
      <MenuItemLink url={props.item.url} opened={props.opened}>
        {[renderMenuIconIfApplicable(props), props.item.text, null]}
      </MenuItemLink>
    );
  };
  function renderMenuIconIfApplicable(props: any) {
    return props.item.icon ? (
      <span
        style={{ fontSize: "16px" }}
        className={`k-icon k-i-${props.item.icon}`}
        role="presentation"
        key="0"
      />
    ) : null;
  }
  return (
    <div style={{ height: "100%", position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: "-20px",
          left: "-20px",
        }}
      >
        <Menu openOnClick={true} onSelect={excelExport} linkRender={linkRender}>
          <MenuItem
            text=""
            icon="more-horizontal"
            data={{}}
            cssStyle={{ color: "black" }}
          >
            <MenuItem text="Export to Excel" />
          </MenuItem>
        </Menu>
      </div>
      <ExcelExport data={data} ref={_export}>
        <Grid
          pageable={isPagable}
          // data={orderBy(data, sort).slice(page.skip, page.take + page.skip)}
          data={data ? orderBy(data, sort) : []}
          // skip={page.skip}
          // take={page.take}
          //   onPageChange={pageChange}

          total={data.length}
          sortable={true}
          sort={sort}
          onSortChange={(e: any) => {
            setSort(e.sort);
          }}
          style={{
            width: "100%",
            height: "100%",
          }}
        >
                  <Column field="fileName" title="Description" cell={descCell} />
          <Column field="path" title="Link" cell={pathCell} />
        </Grid>
      </ExcelExport>
    </div>
  );
};
export default SupportCasessGrid;
